import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteCustomer } from '../../../../actions';

class CustomerDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteCustomer, customerId } = this.props;
    dispatchDeleteCustomer({ customerId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        <i className="fa fa-trash" /> Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

CustomerDeleteButton.propTypes = {
  customerId: PropTypes.number.isRequired,
  dispatchDeleteCustomer: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteCustomer: deleteCustomer,
};

export default connect(null, mapDispatchToProps)(CustomerDeleteButton);
